export enum EmployerPlanTypeEnum {
  DefinedContribution = 1,
  DefinedBenefit = 2
}
